import { render, staticRenderFns } from "./lead.vue?vue&type=template&id=0b4e3db0&scoped=true"
import script from "./lead.vue?vue&type=script&lang=js"
export * from "./lead.vue?vue&type=script&lang=js"
import style0 from "./lead.vue?vue&type=style&index=0&id=0b4e3db0&prod&lang=scss"
import style1 from "./lead.vue?vue&type=style&index=1&id=0b4e3db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4e3db0",
  null
  
)

export default component.exports